// Auto Blocker only intercepts resources that a script inserted. Third-party
// iframes arriving inside WordPress HTML are server-rendered, so Termly cannot
// tell what put them there, tags them data-termly-unknown-parent and lets them
// load before consent. Moving the URL to data-src hands them to Termly's
// manual blocking instead: it renders its own "Enable this content?"
// placeholder and restores src once the category is consented to.
const FIRST_PARTY = /(^|\.)riverworksmarketing\.(com|net)$/i;

const DEFAULT_CATEGORY = "unclassified";

const hostOf = (url) => {
  try {
    return new URL(url, "https://riverworksmarketing.com").hostname;
  } catch (e) {
    return null;
  }
};

const blockThirdPartyIframes = (html, category = DEFAULT_CATEGORY) => {
  if (typeof html !== "string" || !html) return html;

  return html.replace(/<iframe\b[^>]*>/gi, (tag) => {
    // Already blocked, by this function or by hand in a component.
    if (/\sdata-src=/i.test(tag)) return tag;

    const src = tag.match(/\ssrc=["']([^"']+)["']/i);
    if (!src) return tag;

    const host = hostOf(src[1]);
    if (!host || FIRST_PARTY.test(host)) return tag;

    // \ssrc= cannot match data-src= or srcdoc=, so this only moves the real
    // src attribute.
    const blocked = tag.replace(/(\s)src=/i, "$1data-src=");

    return /\sdata-categories=/i.test(blocked)
      ? blocked
      : blocked.replace(/<iframe\b/i, `<iframe data-categories="${category}"`);
  });
};

export default blockThirdPartyIframes;
